import { render, staticRenderFns } from "./TriggerCampaignEdit.vue?vue&type=template&id=4857b14a"
import script from "./TriggerCampaignEdit.vue?vue&type=script&lang=js"
export * from "./TriggerCampaignEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports